
import {apiSlice} from "../features/apiSlice";
import {USERS_URL} from "../util/urlconstants";
import {address} from "framer-motion/m";

//export const USERURL_REGISTER = "http://localhost:5000/api/users";

// Define response & request types
export interface LoginResponse {
    token: string;
}

export interface LoginRequest {
    email: string;
    password: string;
}

export interface EmployeeLoginRequest {
    lastName: string;
    employeeNumber: string;
}

// @ts-ignore
export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => {
        // @ts-ignore
        return {
            //@ts-ignore
            login: builder.mutation<LoginResponse, LoginRequest>({
                //@ts-ignore
                query: (credentials: any) => ({
                    url: `${USERS_URL}/login`,
                    method: "POST",
                    body: credentials,
                }),
            }),

            //@ts-ignore
            employeeLogin: builder.mutation<LoginResponse, EmployeeLoginRequest>({
                query: (credentials: any) => ({
                    url: `${USERS_URL}/employeeLogin`,
                    method: "POST",
                    body: credentials,
                }),
            }),

            logout: builder.mutation({
                query: () => ({
                    url: `${USERS_URL}/logout`,
                    method: "POST",
                })
            }),
            register: builder.mutation({
                query: (data: any) => ({
                    url: `${USERS_URL}/register`,
                    method: "POST",
                    body: data,
                })
            }),
            registerWEmail: builder.mutation({
               query: (data: any) => ({
                   url: `${USERS_URL}/registerEmail`,
                   method: "POST",
                   body: data,
               })
            }),
            profile: builder.mutation({
                query: (data: any) => ({
                    url: `${USERS_URL}/profile`,
                    method: "POST",
                    body: data,
                })
            }),
            getAllUsers: builder.query({
                query: (id: string) => ({
                    url: `${USERS_URL}/${id}`,
                    method: "GET",
                }),
                keepUnusedDataFor: 5,
                providesTags: ["User"],
            }),
            fetchEmployeeByProjectIdList: builder.query({
                query: (projectId: string) => ({
                    url: `${USERS_URL}/fetch/employees/${projectId}`,
                    method: "GET",
                }),
                keepUnusedDataFor: 5,
                providesTags: ["User"],
            }),
            deleteUser: builder.mutation({
                query: (userId: string) => ({
                    url: `${USERS_URL}/${userId}`,
                    method: "DELETE",
                })
            }),
            getUserDetails: builder.query({
                query: (userId: string) => ({
                    url: `${USERS_URL}/${userId}`,
                    method: "GET",
                })
            }),
            updateUser: builder.mutation({
                query: (data: any) => ({
                    url: `${USERS_URL}/${data.id}`,
                    method: "PUT",
                    body: data,
                }),
                invalidateTags: ["User"]
            }),
            verifyEmail: builder.mutation({
                query: (email: any) => ({
                    url: `${USERS_URL}/verifyEmail?email=${email.code}`,
                    method: "POST",
                    body: email,
                    headers: { "Content-Type": "application/json"}
                })
            }),
            resendVerificationCode: builder.mutation({
               query: (email: string) => ({
                   url: `${USERS_URL}/resendCode?email=${email}`,
                   method: "POST",
               })
            }),
            getEmployeeProfile: builder.query({
                query: (userId: string) => ({
                    url: `${USERS_URL}/employee/${userId}`,
                    method: "GET",
                })
            }),
            forgotPassword: builder.mutation({
                query: (data: any) => ({
                    url: `${USERS_URL}/forgotPassword`,
                    method: "POST",
                    body: data,
                })
            }),
            resetPassword: builder.mutation({
                query: (data: {token: string; newPassword: string}) => ({
                    url: `${USERS_URL}/resetPassword?token=${data.token}`,
                    method: "POST",
                    body: {
                        newPassword: data.newPassword
                    },
                    headers: { "Content-Type": "application/json"}
                })
            }),
            fetchEmployeesList: builder.query({
                query: () => ({
                    url: `${USERS_URL}/fetch/employees`,
                    method: "GET",
                })
            }),
            updateEmployeeRegistration: builder.mutation({
                query: (data: any) => ({
                    url: `${USERS_URL}/update/${data.id}`,
                    method: "PUT",
                    body: {
                        email: data.email,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        address: data.address,
                        city: data.city,
                        state: data.state,
                        zip: data.zip,
                        employeeNumber: data.employeeNumber,
                        phoneNumber: data.phoneNumber,
                    }
                }),
                invalidateTags: ["User, Employee"],
            }),

            employeeRegistration: builder.mutation({
                query:({
                    email,
                    address,
                    city,
                    state,
                    zip
                } : {
                    email: string,
                    address: string,
                    city: string,
                    state: string,
                    zip: string
                }) => ({
                    url: `${USERS_URL}/employeeRegistration`,
                    method: "POST",
                    body: {
                        email,
                        address,
                        city,
                        state,
                        zip
                    }
                }),
                invalidatesTags: ["User", "Employees"],
            })

        };
    }
})

export const {
    useLoginMutation,
    useEmployeeLoginMutation,
    useLogoutMutation,
    useRegisterMutation,
    useProfileMutation,
    useDeleteUserMutation,
    useGetAllUsersQuery,
    useVerifyEmailMutation,
    useRegisterWEmailMutation,
    useResendVerificationCodeMutation,
    useResetPasswordMutation,
    useForgotPasswordMutation,
    useEmployeeRegistrationMutation,
    useFetchEmployeesListQuery,
    useFetchEmployeeByProjectIdListQuery,
    useUpdateEmployeeRegistrationMutation,
    useGetEmployeeProfileQuery,
    useGetUserDetailsQuery,
    useUpdateUserMutation,
} = userApiSlice;